<template>
  <div>
    <div class="display-medium" style="margin-bottom: 2rem;">Marketing Tracking</div>
    <el-card>
      <el-form>
        <el-form-item>
          <label>Facebook Pixel</label>
          <el-input v-model.trim="settings.pixel.id" placeholder="Facebook Pixel ID" />
          <div class="display-caption subdued">For more help, head to the <a href="https://developers.facebook.com/docs/facebook-pixel/implementation" target="_blank">Facebook Pixel Implementation documentation</a>.</div>
        </el-form-item>
        <el-form-item>
          <label>What events would you like to track on your Landing Page?</label>
          <div>
            <el-checkbox v-model="settings.pixel.pageview" label="PageView Event"></el-checkbox>
            <el-checkbox v-model="settings.pixel.purchase" label="Purchase Event"></el-checkbox>
            <el-checkbox v-model="settings.pixel.lead" label="Lead Event"></el-checkbox>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="xpl-button xpl-button--primary" @click="saveTracking" :loading="isLoading">Save</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card v-if="false">
      <el-form>
        <el-form-item>
          <label>Google Conversion ID</label>
          <el-input v-model.trim="settings.google.id" placeholder="Google Conversion ID" />
          <div class="display-caption subdued">For more help, head to the <a href="https://support.google.com/google-ads/answer/6095821" target="_blank">Google Conversion Tracking documentation</a>.</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="xpl-button xpl-button--primary" @click="saveTracking" :loading="isLoading">Save</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
  import EventBus from '@/event-bus';
  import * as api from '@/api';

  export default {
    props: ['checkoutflow'],
    data() {
      return {
        isLoading: false,
        settings: {
          pixel: {
            id: null,
            pageview: true,
            purchase: true,
            lead: true,
          },
          google: {
            id: null,
          },
        },
      };
    },
    created() {
      if (this.checkoutflow.settings) {
        const keys = Object.keys(this.checkoutflow.settings);
        // eslint-disable-next-line
        for (let i = keys.length - 1; i >= 0; i--) {
          this.$set(this.settings, keys[i], this.checkoutflow.settings[keys[i]]);
        }
      }
    },
    methods: {
      saveTracking() {
        this.isLoading = true;
        const payload = {
          settings: {
            pixel: {
              id: this.settings.pixel.id,
              pageview: this.settings.pixel.pageview,
              purchase: this.settings.pixel.purchase,
              lead: this.settings.pixel.lead,
            },
            google: {
              id: this.settings.google.id,
            },
          },
        };

        api.updateCheckoutFlow(payload, this.checkoutflow.id).then((response) => {
          this.isLoading = false;
          this.$message.success(response.message);
          EventBus.$emit('checkoutflow.refresh');
        }).catch((err) => {
          this.isLoading = false;
          this.$message.error(err.message);
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .el-card + .el-card {
    margin-top: 2rem;
  }
</style>
